export class ItemConstants {
  public static ITEMS: string = 'items'
  public static FAVOURITES: string = 'favourites'
  public static ITEMS_UUID: string = ':uuid'
}
